import { useQuery } from '@tanstack/react-query'
import { practiceApi } from '../api/practice.api'

export const TOPICS_QUERY_KEY = ['knowledge', 'topics'] as const

/** Arbre complet des topics actifs (SPEC §6.1, §12, `GET /topics`), mis en cache côté serveur. */
export function useTopics() {
  return useQuery({
    queryKey: TOPICS_QUERY_KEY,
    queryFn: () => practiceApi.fetchTopics().then((response) => response.data.data),
    staleTime: 5 * 60_000,
  })
}
